import { Component, ChangeDetectionStrategy } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
    selector: 'app-root',
    template: `
    <alert></alert>
    <router-outlet></router-outlet>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
  constructor(translateService: TranslateService) {
    // Admin is internal-only and fixed to pt-BR (out of i18n scope).
    translateService.use('pt-BR')
  }
}
